import React from 'react';
import '../home/home.scss'
import {Container} from "react-bootstrap";
import ContactForm from "../../components/contactForm";


const WorkPage = () => {
    return (
        <Container>
            <h1 className='header'>Jobba med oss</h1>
            <ContactForm expectAttachment={true}></ContactForm>
        </Container>
    )
}
export default WorkPage;
